import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
//import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'

import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const CreateContentAssociationType = () => {
  const [message, setMessage] = useState("");

	const token = globalConfig.hardcoded_header;
  const [state, setState] = useState({
    contentAssociationTypeId: 0,
    contentAssociationTypeName: "",
    contentAssociationTypeDescr: "",
    contentAssociationTypeAppid: 0,
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
  });

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({ ...state, [target.id]: target.value });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-association-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-association-types/contentAssociationTypeId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentAssociationTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentAssociationTypeId
          );
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      setState({
        ...state,
        contentAssociationTypeName: "",
        contentAssociationTypeDescr: "",
      });
    });

    // console.log("SetState Message info-" + this.contentFacadeTypeId);
    // console.log("SetState Message info-" + this.contentFacadeName);
  }

  function handleRest() {
    setState({
      ...state,
      contentAssociationTypeName: "",
      contentAssociationTypeDescr: "",
    });
  }

  useEffect(() => {
    handleOnLoad();
  }, []);

  const handleOnLoad = () => {};
  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Assocaiation Type</h4>			
			<Link to="/breeze/list-content-association-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Type Name"
          >
            Content Association Type name
          </label>
          <input
            id="contentAssociationTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Type Description"
          >
            Content Association Type Description
          </label>
          <textarea
            id="contentAssociationTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentAssociationTypeDescr}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Association Application"
          >
            Content Association Application
          </label>
          <select
            id="contentAssociationTypeId"
            value="#{ombContentAssociationTypeForm.createContentAssociationType.contentAssociationTypeAppid}"
            className="form-control input-xlarge col-sm-8"
          >
            <option value="#{ombContentAssociationTypeForm.contentApplicationSelectList}" />
          </select>
        </div>
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handleRest}>
          {" "}
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          {" "}
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentAssociationType;
